import { useState } from 'react';
import classNames from 'classnames';

export const useToggleSection = (initialState = false) => {
  const [isHidden, setIsHidden] = useState(initialState);

  const className = classNames('toggle-section', {
    'toggle-hidden': isHidden,
  });

  const toggle = () => setIsHidden(!isHidden);

  return {
    isHidden,
    setIsHidden,
    className,
    toggle,
    isExpanded: !isHidden,
  };
};
